<template>
    <div
        id="top-bar-secondary-wrapper"
        class="top-bar-secondary"
        v-if="!renderCI"
    >
        <b-navbar
            type="light"
            class="module-navbar w-100"
            :toggleable="navbarToggleBreakpoint"
        >
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse id="nav_dropdown_collapse" is-nav>
                <slot name="module-action-left"></slot>
            </b-collapse>

            <slot name="module-action-right"></slot>
        </b-navbar>
    </div>
</template>
<script>
export default {
    name: "TopBarSecondaryClassic",
    props: {
        renderCI: {
            type: Boolean,
            default: false
        },
        navbarToggleBreakpoint: {
            type: String,
            default: "md"
        }
    }
};
</script>
<style lang="scss" scoped>
$navbar-primary-height: 64px;
$navbar-secondary-height: 50px;

.top-bar-secondary {
    display: flex;
    background: #c9ccde;
    z-index: 1001;

    .submenus {
        flex-grow: 1;

        ::v-deep ul:first-of-type.navbar-nav > li > a {
            white-space: nowrap;
            display: inline-flex;
            align-items: center;
            gap: 4px;
        }
    }
}

.submenus {
    display: none;
}

.nav-utility {
    display: none;
}

@media (min-width: 992px) {
    .top-bar-secondary {
        align-items: center;
        position: fixed;
        top: $navbar-primary-height;
        left: 0;
        right: 0;

        .module-navbar {
            height: $navbar-secondary-height;
        }
    }
}
</style>
